import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "../StyledComponents";
import { useNavigate } from "react-router-dom";

const CheckLanguage = (props) => {
  const navigate = useNavigate();
  const language = useSelector((state) => state.tableorder.language);
  const [checkLanguage, setCheckLanguage] = useState(false);

  useEffect(() => {
    const check_language = Object.entries(language).map(([key, value]) => (key === "ko" ? false : value)).every(value => value === false);
    setCheckLanguage(check_language);
  }, []);

  const press_setting = () => {
    navigate('/tablet-order/setting')
  };

  return checkLanguage 
  ? <div style={{display:'flex', flexDirection:'column', alignItems:'center', padding:'32px 0', gap:16}}>
      <p style={{fontSize: 14, textAlign:'center', color:'#f95f53'}}>새로 생긴 다국어 기능을 사용해보세요!</p>
        <Button variant="sub" style={{margin: '0 auto'}} small className='save-btn' fontSize={16} onClick={press_setting} style={{width: 180}}>
            다국어 기능 설정하기
        </Button>
    </div> 
  : props.children;
};

export default CheckLanguage;
